/**
 * Quick Add — variant picker modal + AJAX cart + confirmation modal
 *
 * Triggers:
 *   [data-quick-add-direct="variantId"]  → add directly (silent) or show confirm
 *   [data-quick-add-modal="handle"]       → fetch variants, show variant picker
 *
 * Confirmation mode (data-cart-confirm on <body>):
 *   "confirm"  → show cart-confirm-modal before adding
 *   "silent"   → add silently with checkmark feedback
 *
 * Dispatches:
 *   cart:updated (document) — { count, item }
 */

(function () {
  'use strict';

  /* ════════════════════════════════════════════
     Variant picker modal (#quick-add-modal)
     ════════════════════════════════════════════ */

  var qaModal   = document.getElementById('quick-add-modal');
  var skeleton  = qaModal?.querySelector('[data-qa-skeleton]');
  var qaBody    = qaModal?.querySelector('[data-qa-body]');
  var qaAddBtn  = qaModal?.querySelector('[data-qa-add]');
  var qaAddLbl  = qaModal?.querySelector('[data-qa-add-label]');

  var currentVariants = [];
  var selectedVariant = null;

  function openQaModal() {
    if (!qaModal) return;
    qaModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeQaModal() {
    if (!qaModal) return;
    qaModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    selectedVariant = null;
    currentVariants = [];
    if (qaBody)    qaBody.innerHTML = '';
    if (skeleton)  skeleton.hidden  = false;
    if (qaAddBtn)  qaAddBtn.disabled = true;
    if (qaAddLbl)  qaAddLbl.textContent = (window.StratOSLocales && window.StratOSLocales.products.add_to_cart) || 'Ajouter au panier';
  }

  qaModal?.querySelectorAll('[data-qa-close]').forEach(function (el) {
    el.addEventListener('click', closeQaModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (qaModal?.getAttribute('aria-hidden') === 'false') closeQaModal();
    if (ccModal?.getAttribute('aria-hidden') === 'false') closeCcModal();
  });

  /* Fetch product JSON */
  function loadProduct(handle) {
    if (skeleton) skeleton.hidden = false;
    if (qaBody)   qaBody.innerHTML = '';
    if (qaAddBtn) qaAddBtn.disabled = true;

    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Product not found');
        return r.json();
      });
  }

  /* Render variant picker */
  function renderProduct(product, preselectOpt0) {
    currentVariants = product.variants;
    if (skeleton) skeleton.hidden = true;

    var firstImg = product.images[0]
      ? '<img src="' + product.images[0] + '" alt="' + escHtml(product.title) + '" class="qa-modal__img" loading="lazy">'
      : '';

    var price = formatMoney(product.variants[0].price);
    var comparePrice = '';
    if (product.variants[0].compare_at_price > product.variants[0].price) {
      comparePrice = '<s class="qa-modal__compare-price">' + formatMoney(product.variants[0].compare_at_price) + '</s>';
    }

    var optionsHtml = product.options.map(function (opt, optIndex) {
      var optName   = (typeof opt === 'object' && opt !== null) ? opt.name : String(opt);
      var optValues = (typeof opt === 'object' && opt !== null && Array.isArray(opt.values))
        ? opt.values
        : [...new Set(product.variants.map(function (v) { return v['option' + (optIndex + 1)]; }))];

      var pills = optValues.map(function (val) {
        var available = product.variants.some(function (v) {
          return v['option' + (optIndex + 1)] === val && v.available;
        });
        return '<button type="button"'
          + ' class="qa-modal__option-pill' + (available ? '' : ' is-unavailable') + '"'
          + ' data-opt-index="' + optIndex + '"'
          + ' data-opt-value="' + escHtml(val) + '"'
          + (available ? '' : ' aria-label="' + escHtml(val) + ' — épuisé"')
          + '>' + escHtml(val) + '</button>';
      }).join('');

      return '<div class="qa-modal__option-group">'
        + '<span class="qa-modal__option-label">' + escHtml(optName) + '</span>'
        + '<div class="qa-modal__option-pills" data-opt-group="' + optIndex + '">' + pills + '</div>'
        + '</div>';
    }).join('');

    if (qaBody) {
      qaBody.innerHTML =
        '<div class="qa-modal__product">'
        + firstImg
        + '<div class="qa-modal__product-info">'
        + '<h3 class="qa-modal__product-title">' + escHtml(product.title) + '</h3>'
        + '<div class="qa-modal__price">' + price + (comparePrice ? ' ' + comparePrice : '') + '</div>'
        + '</div>'
        + '</div>'
        + optionsHtml;

      qaBody.querySelectorAll('.qa-modal__option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var groupIdx = parseInt(pill.dataset.optIndex, 10);
          qaBody.querySelectorAll('[data-opt-group="' + groupIdx + '"] .qa-modal__option-pill')
            .forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          matchVariant(product);
        });
      });

      product.options.forEach(function (opt, i) {
        var target = null;
        if (i === 0 && preselectOpt0) {
          target = qaBody.querySelector('[data-opt-group="0"] .qa-modal__option-pill[data-opt-value="' + preselectOpt0.replace(/"/g, '\\"') + '"]');
        }
        if (!target) {
          target = qaBody.querySelector('[data-opt-group="' + i + '"] .qa-modal__option-pill:not(.is-unavailable)');
        }
        target?.click();
      });
    }
  }

  function matchVariant(product) {
    var selected = [];
    product.options.forEach(function (opt, i) {
      var pill = qaBody?.querySelector('[data-opt-group="' + i + '"] .qa-modal__option-pill.is-selected');
      selected.push(pill ? pill.dataset.optValue : null);
    });

    selectedVariant = product.variants.find(function (v) {
      return selected.every(function (val, i) { return v['option' + (i + 1)] === val; });
    }) || null;

    if (selectedVariant && selectedVariant.available) {
      if (qaAddBtn) qaAddBtn.disabled = false;
      var lAtc = (window.StratOSLocales && window.StratOSLocales.products.add_to_cart) || 'Ajouter au panier';
      if (qaAddLbl) qaAddLbl.textContent = lAtc + ' — ' + formatMoney(selectedVariant.price);
    } else {
      if (qaAddBtn) qaAddBtn.disabled = true;
      var lSoldOut  = (window.StratOSLocales && window.StratOSLocales.products.sold_out)       || 'Épuisé';
      var lChooseOp = (window.StratOSLocales && window.StratOSLocales.products.choose_options)  || 'Choisir une option';
      if (qaAddLbl) qaAddLbl.textContent = selectedVariant ? lSoldOut : lChooseOp;
    }
  }

  /* Variant picker confirm button */
  qaAddBtn?.addEventListener('click', function () {
    if (!selectedVariant) return;
    ajaxAddToCart(selectedVariant.id, null, 'qa-modal').then(function () {
      var lAdded = (window.StratOSLocales && window.StratOSLocales.cart.added) || 'Ajouté au panier';
      if (qaAddLbl) qaAddLbl.textContent = '✓ ' + lAdded;
      qaAddBtn && qaAddBtn.classList.add('is-success');
      window.StratOSToast && window.StratOSToast.show(lAdded, 'success');
      setTimeout(closeQaModal, 1200);
    }).catch(function (err) {
      var lError = (window.StratOSLocales && window.StratOSLocales.general.error) || 'Erreur — veuillez réessayer';
      var msg = err.message || lError;
      if (qaAddLbl) qaAddLbl.textContent = msg;
      window.StratOSToast && window.StratOSToast.show(msg, 'error');
      var lAtc = (window.StratOSLocales && window.StratOSLocales.products.add_to_cart) || 'Ajouter au panier';
      setTimeout(function () {
        if (qaAddLbl) qaAddLbl.textContent = lAtc;
      }, 2200);
    });
  });

  /* ════════════════════════════════════════════
     Confirmation modal (#cart-confirm-modal)
     ════════════════════════════════════════════ */

  var ccModal      = document.getElementById('cart-confirm-modal');
  var ccImg        = ccModal?.querySelector('[data-cc-img]');
  var ccVariant    = ccModal?.querySelector('[data-cc-variant]');
  var ccTitle      = ccModal?.querySelector('[data-cc-title]');
  var ccPrice      = ccModal?.querySelector('[data-cc-price]');
  var ccDesc       = ccModal?.querySelector('[data-cc-desc]');
  var ccConfirmBtn = ccModal?.querySelector('[data-cc-confirm]');
  var ccConfirmLbl = ccModal?.querySelector('[data-cc-confirm-label]');

  var pendingVariantId = null;
  var pendingTrigger   = null;

  function openCcModal(variantId, triggerEl, productData) {
    if (!ccModal) return;

    pendingVariantId = variantId;
    pendingTrigger   = triggerEl;

    /* Populate */
    if (ccImg) {
      ccImg.src = productData.image || '';
      ccImg.alt = productData.title || '';
      ccImg.style.display = productData.image ? '' : 'none';
    }
    if (ccVariant) ccVariant.textContent = productData.variantTitle || '';
    if (ccTitle)   ccTitle.textContent   = productData.title || '';
    if (ccPrice)   ccPrice.textContent   = productData.price || '';
    if (ccDesc) {
      ccDesc.textContent = productData.desc || '';
      ccDesc.style.display = productData.desc ? '' : 'none';
    }
    if (ccConfirmLbl) {
      var lAtc = (window.StratOSLocales && window.StratOSLocales.products.add_to_cart) || 'Ajouter au panier';
      ccConfirmLbl.textContent = lAtc + (productData.price ? ' — ' + productData.price : '');
    }
    ccConfirmBtn?.classList.remove('is-loading', 'is-success');

    ccModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCcModal() {
    if (!ccModal) return;
    ccModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    pendingVariantId = null;
    pendingTrigger   = null;
  }

  ccModal?.querySelectorAll('[data-cc-close]').forEach(function (el) {
    el.addEventListener('click', closeCcModal);
  });

  /* Confirm button → actually add */
  ccConfirmBtn?.addEventListener('click', function () {
    if (!pendingVariantId) return;
    ajaxAddToCart(pendingVariantId, ccConfirmBtn, 'cc-modal').then(function () {
      if (ccConfirmLbl) ccConfirmLbl.textContent = '✓ Ajouté au panier !';
      ccConfirmBtn?.classList.add('is-success');

      /* Restore trigger to success state briefly */
      if (pendingTrigger) {
        var origLabel = pendingTrigger.textContent;
        pendingTrigger.classList.add('is-added');
        pendingTrigger.textContent = '✓';
        setTimeout(function () {
          pendingTrigger?.classList.remove('is-added');
          pendingTrigger.textContent = origLabel;
        }, 2000);
      }
      setTimeout(closeCcModal, 1000);
    }).catch(function (err) {
      var lError = (window.StratOSLocales && window.StratOSLocales.general.error) || 'Erreur — réessayer';
      if (ccConfirmLbl) ccConfirmLbl.textContent = err.message || lError;
      var lAtc = (window.StratOSLocales && window.StratOSLocales.products.add_to_cart) || 'Ajouter au panier';
      setTimeout(function () {
        if (ccConfirmLbl) ccConfirmLbl.textContent = lAtc;
      }, 2500);
    });
  });

  /* ════════════════════════════════════════════
     AJAX Cart
     ════════════════════════════════════════════ */

  function ajaxAddToCart(variantId, loadingEl, context) {
    if (context === 'qa-modal') {
      if (qaAddBtn) { qaAddBtn.disabled = true; qaAddBtn.classList.add('is-loading'); }
    } else if (context === 'cc-modal') {
      if (ccConfirmBtn) { ccConfirmBtn.disabled = true; ccConfirmBtn.classList.add('is-loading'); }
    } else if (loadingEl) {
      loadingEl.classList.add('is-loading');
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Erreur'); });
      return r.json();
    })
    .then(function (item) {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        window.pubsub && window.pubsub.publish('cart:updated', cart);
        return item;
      });
    })
    .finally(function () {
      if (context === 'qa-modal') {
        if (qaAddBtn) { qaAddBtn.classList.remove('is-loading'); qaAddBtn.disabled = false; }
      } else if (context === 'cc-modal') {
        if (ccConfirmBtn) { ccConfirmBtn.classList.remove('is-loading'); ccConfirmBtn.disabled = false; }
      } else if (loadingEl) {
        loadingEl.classList.remove('is-loading');
      }
    });
  }

  /* ════════════════════════════════════════════
     Global click handler
     ════════════════════════════════════════════ */

  var confirmMode = document.body.dataset.cartConfirm === 'confirm';

  document.addEventListener('click', function (e) {

    /* Direct add trigger */
    var directBtn = e.target.closest('[data-quick-add-direct]');
    if (directBtn) {
      var variantId = directBtn.dataset.quickAddDirect;

      if (confirmMode) {
        /* Read product data from nearest product-card */
        var card = directBtn.closest('[data-product-title]');
        var productData = {
          title:        card?.dataset.productTitle || '',
          image:        card?.dataset.productImage || '',
          desc:         card?.dataset.productDesc  || '',
          variantTitle: directBtn.dataset.variantTitle || '',
          price:        directBtn.dataset.priceCents
            ? formatMoney(parseInt(directBtn.dataset.priceCents, 10))
            : ''
        };
        openCcModal(variantId, directBtn, productData);

      } else {
        /* Silent mode */
        var origLabel = directBtn.textContent.trim();
        var isInline  = directBtn.classList.contains('quick-add-inline__pill');
        var isSinglePill = directBtn.classList.contains('quick-add-inline__pill--single');
        var checkSvg = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
        var cartSvg  = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

        ajaxAddToCart(variantId, directBtn, 'silent').then(function () {
          directBtn.classList.add('is-added');
          directBtn.innerHTML = checkSvg;
          setTimeout(function () {
            directBtn.classList.remove('is-added');
            /* Pill texte (S, M, L…) → restaurer le label ; sinon → icône panier */
            if (isInline && !isSinglePill) {
              directBtn.textContent = origLabel;
            } else {
              directBtn.innerHTML = cartSvg;
            }
          }, 1800);
        }).catch(function (err) {
          directBtn.classList.remove('is-loading');
          var lErrAdd = (window.StratOSLocales && window.StratOSLocales.cart.error_add) || 'Impossible d\'ajouter ce produit. Veuillez réessayer.';
          window.StratOSToast && window.StratOSToast.show(
            err.message || lErrAdd,
            'error'
          );
        });
      }
      return;
    }

    /* Variant picker modal trigger */
    var modalTrigger = e.target.closest('[data-quick-add-modal]');
    if (modalTrigger) {
      var handle     = modalTrigger.dataset.quickAddModal;
      var preselect0 = modalTrigger.dataset.preselect0 || null;

      openQaModal();
      loadProduct(handle).then(function (product) {
        renderProduct(product, preselect0);
      }).catch(function () {
        var lErrLoad = (window.StratOSLocales && window.StratOSLocales.cart.error_load) || 'Impossible de charger ce produit.';
        if (skeleton) skeleton.hidden = true;
        if (qaBody)   qaBody.innerHTML = '<p class="qa-modal__error">' + lErrLoad + '</p>';
      });
    }
  });

  /* ════════════════════════════════════════════
     Cart count badge update
     ════════════════════════════════════════════ */

  document.addEventListener('cart:updated', function (e) {
    var count = e.detail?.count ?? 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  });

  /* ════════════════════════════════════════════
     Helpers
     ════════════════════════════════════════════ */

  function formatMoney(cents) {
    if (window.ShopUtils && window.ShopUtils.formatMoney) {
      return window.ShopUtils.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + '\u00a0€';
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();
